import "@/App.css";
import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import TopBar from "@/components/TopBar";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import AnalyticsProvider from "@/components/AnalyticsProvider";
import { captureAttribution } from "@/lib/attribution";
import Home from "@/pages/Home";

// Route-level code splitting: every secondary route ships as its own JS chunk,
// so the homepage payload stays minimal and crawler/first-paint timing improves
// dramatically on /careers, /resources, /xcellereyes, /contact, /about.
const XcellerEyes = lazy(() => import("@/pages/XcellerEyes"));
const Resources = lazy(() => import("@/pages/Resources"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const Careers = lazy(() => import("@/pages/Careers"));
const AdminLeads = lazy(() => import("@/pages/AdminLeads"));

function RouteFallback() {
  return (
    <div data-testid="route-loading" className="min-h-screen flex items-center justify-center bg-cloud">
      <div className="h-10 w-10 rounded-full border-2 border-teal/20 border-t-teal animate-spin" />
    </div>
  );
}

function App() {
  useEffect(() => { captureAttribution(); }, []);
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AnalyticsProvider />
          <TopBar />
          <Navigation />
          <main className="min-h-screen">
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/xcellereyes" element={<XcellerEyes />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/admin/leads" element={<AdminLeads />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
